var _style, _rect, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgWheel = function SvgWheel(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 235.1 235",
    style: {
      enableBackground: "new 0 0 235.1 235"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{display:none;opacity:0.4;fill:url(#SVGID_1_);}\n\t.st1{fill:#1A1A1A;}\n\t.st2{fill:#4F52A3;}\n")), /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_1_",
    cx: 58.8243,
    cy: -101.3961,
    r: 313.8896,
    gradientTransform: "matrix(1.0558 0 0 1.0559 55.4558 234.5642)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3519,
    style: {
      stopColor: "#FDFDFD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5151,
    style: {
      stopColor: "#F5F5F6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6394,
    style: {
      stopColor: "#E9E9E9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.744,
    style: {
      stopColor: "#D6D7D7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8362,
    style: {
      stopColor: "#BFBFC0"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9184,
    style: {
      stopColor: "#A2A3A3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9939,
    style: {
      stopColor: "#808182"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#7D7E7F"
    }
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -107.4,
    y: -97.5,
    className: "st0",
    width: 450,
    height: 450
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M230.3,150.7l4.8-27.5L227,117c0-0.3,0-0.6,0-0.9l7.9-6.1l-4.8-27.5l-9.7-3.1c-0.1-0.3-0.2-0.6-0.3-0.9 l5.4-8.4L211.5,46l-10.2,0.4c-0.2-0.2-0.4-0.4-0.6-0.7l2.2-9.8l-21.3-17.9l-9.4,3.9c-0.3-0.2-0.5-0.3-0.8-0.5l-1.3-9.9L144,2.1 L136.4,9c-0.3-0.1-0.6-0.1-0.9-0.2L130.9,0h-27.8l-4.7,9.1c-0.3,0.1-0.6,0.1-0.9,0.2l-7.4-6.8L64,12l-1.3,10.2 c-0.3,0.2-0.5,0.3-0.8,0.5l-9.2-3.8L31.4,36.7l2.2,10c-0.2,0.2-0.4,0.5-0.6,0.7l-10-0.4L9.2,71.1l5.5,8.6 c-0.1,0.3-0.2,0.6-0.3,0.9l-9.5,3L0,111.1l8.1,6.2c0,0.3,0,0.6,0,0.9l-7.9,6.1L5,151.8l9.7,3.1c0.1,0.3,0.2,0.6,0.3,0.9l-5.4,8.4 l13.9,24.1l10.2-0.4c0.2,0.2,0.4,0.4,0.6,0.7l-2.2,9.8l21.3,17.9l9.4-3.9c0.3,0.2,0.5,0.3,0.8,0.5l1.3,9.9l26.1,9.5l7.5-6.9 c0.3,0.1,0.6,0.1,0.9,0.2l4.6,8.9H132l4.7-9.1c0.3-0.1,0.6-0.1,0.9-0.2l7.4,6.8l26.1-9.5l1.3-10.2c0.3-0.2,0.5-0.3,0.8-0.5 l9.2,3.8l21.3-17.9l-2.2-10c0.2-0.2,0.4-0.5,0.6-0.7l10,0.4l13.9-24.1l-5.5-8.6c0.1-0.3,0.2-0.6,0.3-0.9L230.3,150.7z  M119.2,203.9c-47.8,0.9-87.2-37.2-88.1-85.1C30.2,70.9,68.2,31.3,116,30.4c47.8-0.9,87.2,37.2,88.1,85.1 C205,163.5,166.9,203,119.2,203.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M117.8,131.8c-8.1,0.2-14.7-6.3-14.9-14.4c-0.2-8.1,6.3-14.8,14.3-14.9c8.1-0.2,14.7,6.3,14.9,14.4 C132.3,125,125.9,131.7,117.8,131.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M116.1,39.4C73.3,40.2,39.2,75.7,40,118.6c0.8,42.9,36.1,77.1,79,76.3c42.8-0.8,76.9-36.3,76.1-79.2 C194.3,72.8,158.9,38.6,116.1,39.4z M116.3,49.9c11.6-0.2,22.7,2.5,32.3,7.6c-1.9,6.5-5,12.5-9.2,17.4 c-5.9,6.9-13.7,11.1-21.7,11.8c-0.5,0-0.9,0-1.4,0c-8.1-0.4-16-4.3-22.2-10.9c-4.4-4.7-7.7-10.5-9.8-17 C93.8,53.3,104.7,50.1,116.3,49.9z M144.6,122.8c2.1-0.7,4.4,0.4,5.1,2.5c0.7,2.1-0.4,4.4-2.4,5.2c-2.1,0.7-4.4-0.4-5.1-2.5 C141.4,125.9,142.5,123.6,144.6,122.8z M117.2,95.9c11.7-0.2,21.4,9.1,21.6,20.9c0.2,11.7-9.1,21.4-20.8,21.7 c-11.7,0.2-21.4-9.1-21.6-20.9C96.1,105.8,105.5,96.1,117.2,95.9z M96.2,94.3c-0.7-2.1,0.4-4.4,2.4-5.2c2.1-0.7,4.4,0.4,5.1,2.5 c0.7,2.1-0.4,4.4-2.4,5.2C99.2,97.5,96.9,96.4,96.2,94.3z M136.2,96.6c-2.1,0.7-4.4-0.4-5.1-2.5c-0.7-2.1,0.4-4.4,2.4-5.2 c2.1-0.7,4.4,0.4,5.1,2.5C139.4,93.6,138.3,95.9,136.2,96.6z M90.8,131.2c-2.1,0.7-4.4-0.4-5.1-2.5c-0.7-2.1,0.4-4.4,2.4-5.2 c2.1-0.7,4.4,0.4,5.1,2.5C94,128.1,92.9,130.4,90.8,131.2z M50.2,118.7c-0.4-19.3,7.4-36.9,20.1-49.4C76,73.1,80.7,77.9,84,83.4 c3.3,5.5,5.1,11.4,5.2,17.1c0,2.5-0.2,4.9-0.8,7.2c-0.1,0.5-0.2,0.9-0.4,1.3c-2.8,7.6-9,13.9-17.2,17.8 c-5.8,2.7-12.4,4.1-19.2,4.1C50.8,127,50.3,122.9,50.2,118.7z M110.1,184.6c-23.1-2.6-42.8-16.9-52.8-37 c5.4-4.2,11.4-7.2,17.6-8.7c8.9-2.1,17.6-0.9,24.5,3.3c0.4,0.2,0.8,0.5,1.1,0.8c6.3,5.1,10.4,12.9,11.5,21.9 c0.2,1.4,0.3,2.8,0.3,4.3C112.5,174.3,111.7,179.5,110.1,184.6z M119.7,151.1c-2.1,0.7-4.4-0.4-5.1-2.5c-0.7-2.1,0.4-4.4,2.4-5.2 c2.1-0.7,4.4,0.4,5.1,2.5C122.9,148,121.8,150.3,119.7,151.1z M127.6,184.2c-1.8-5-2.8-10.1-2.9-15.2c0-1.4,0-2.9,0.1-4.3 c0.8-9.1,4.6-17,10.7-22.3c0.4-0.3,0.7-0.6,1.1-0.8c6.8-4.5,15.4-6,24.3-4.2c6.3,1.2,12.4,4,17.9,8 C169.7,165.8,150.6,180.8,127.6,184.2z M164.7,125.1c-8.4-3.5-14.7-9.6-17.9-17.1c-0.2-0.4-0.3-0.9-0.5-1.3c-0.6-2.3-1-4.8-1-7.2 c0,0,0,0,0,0c-0.1-5.8,1.5-11.7,4.6-17.3c3.1-5.6,7.6-10.6,13.1-14.6c13.2,12.1,21.6,29.3,21.9,48.6c0.1,4.2-0.2,8.3-0.9,12.3 C177.2,128.8,170.6,127.6,164.7,125.1z"
  })))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWheel, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/wheel.ee7c9f8d.svg";
export { ForwardRef as ReactComponent };